import React,  { Component } from 'react';
import {withStyles} from '@material-ui/core/styles';
import { Link } from "react-router-dom";

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip';

import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'


import ListSimple from '../../component/DragAndDrop/ListSimple'


//services
import CompanyService from '../../services/CompanyService'
import UserService from '../../services/UserService'
import DatasetDynamicService from '../../services/DatasetDynamicService'

const useStyles = (theme) => ({
  root: {    
    marginBottom: '1rem',
    marginTop: '1rem',
  },

  paper: {
    padding: theme.spacing(2),      
    color: theme.palette.text.secondary,    
  },   
})

class DatasetOrders extends Component {

  constructor(props){
    super(props)    
    this.state = {
      companiesSelected: {id:'', label:''},
      companies: [],
      usersSelected: [],
      users: [],
      datasets: [],
    }
                      
  }

  handleSearch = (company, users) => {
    if(!company || !users) return;

    
    const param = {
      company: company,
      user: users,      
    }
    const response = DatasetDynamicService.forOrdered(param)
    response
      .then((resp) => {
        this.setState({datasets: resp.data})
      })
      .catch((error) => console.error(error))
  }

  componentDidMount(prevProps, prevState){    
    
  }

  handleCompanySelectItem = (option, param) => {        
    this.setState({companiesSelected: param})    
    this.searchUsersByCompany(param)        
  }

  searchUsersByCompany = (param) => {
      
    if(!param || !param.id) return

    const userResponse = UserService.user([param.id])

    userResponse
      .then( resp => {                    
        this.setState({users: resp.data})  
      })
      .catch(err => {
        console.error(err)
      })
  }

  handleSearchCompanyDefault = () => {                  
    this.searchCompanyByTerm('ads')  
  }

  searchCompanyByTerm = (term) => {    

    if(!term || term.length < 2) return 

    this.setState({loadingCompany:true})
    const companiesResponse = CompanyService.companies(term)
    companiesResponse
      .then(resp => {                
        this.setState({
          companies:resp.data, 
          loadingCompany:false
        })        
      })
      .catch(err => {
        this.setState({loadingCompany:false})
        console.error(err)
      })    
  }

  handleCompany = (event) => {                  
    this.searchCompanyByTerm(event.target.value.trim())  
  }

  handlerUserslectItem = (option, param) => {        
    this.setState({
      datasets: [],
      usersSelected:param
    })      
    const company = this.state.companiesSelected && this.state.companiesSelected.id?this.state.companiesSelected.id:null
    const users = param.length > 0 ? param.map( u=>u.id) : null
    this.handleSearch(company, users)  
  }
    
  handleOrder = (newOrder) => {
    const response = DatasetDynamicService.saveNewOrder(newOrder)
    response
      .then((resp) => console.log(resp))
      .catch((error)=> console.error(error))
  }

  render(){

    const { classes} = this.props;

    return(
      <Grid container spacing={2}>
        
        <Grid item xs={12} >
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" to="/"  >
                <Home/>
              </Link>            
              <Typography color="textPrimary">Ordernação de Dashboard</Typography>
            </Breadcrumbs>
        </Grid>      

        <Grid item xs={12}>
          <Paper className={classes.paper} >
            <Autocomplete     
                value={this.state.companiesSelected}                     
                onChange={this.handleCompanySelectItem}   
                onKeyUp={this.handleCompany}
                filterSelectedOptions                
                options={this.state.companies}        
                getOptionLabel={(option) => {                                    
                  return option.id +" - " + option.label;
                }}       
                getOptionSelected={(option, value) => option.label === value.label}    
                renderOption={(option) => {                                    
                  return `${option.id} | ${option.label} | ${option.identifier ? `cnpj ${option.identifier}`:''}`
                }}   
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip                                  
                        color="primary" 
                        label={option.id + ' ' + option.label} 
                        {...getTagProps({ index })} 
                        />
                  ))
                } 
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onClick={this.handleSearchCompanyDefault}
                    variant="standard"
                    label="Empresas"
                    placeholder="Selecione"
                  />
                )}
              />

              <Autocomplete
                multiple
                value={this.state.usersSelected}
                filterSelectedOptions            
                options={this.state.users}
                getOptionLabel={(option) => option.username}  
                getOptionSelected={(option, value) => option.username === value.username}    
                onChange={this.handlerUserslectItem}
                renderOption={(option) => {                                    
                  return `${option.id} | ${option.label} | ${option.username}`
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip color="primary" label={option.label} {...getTagProps({ index })} />
                  ))
                }              
                renderInput={(params) => (
                  <TextField
                    label="Usuários"
                    {...params}
                    variant="standard"                    
                  />
                )}
              /> 
            </Paper>  
        </Grid>    

         <Grid item xs={12} className={classes.formControl} >
            <ListSimple datasets={this.state.datasets} onEventChange={this.handleOrder} />              
         </Grid>               
      </Grid>                 
    )
  }
}

export default withStyles(useStyles)(DatasetOrders)